import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Segment, Image, Item, Button, Header } from "semantic-ui-react";
import CardImage from "../Images/culture.jpg";
import {
    selectedCategory,
    selectedTest
} from "../../features/selections/selectActions";

const eventImageStyle = {
    filter: "brightness(30%)"
};

const eventImageTextStyle = {
    position: "absolute",
    bottom: "5%",
    left: "5%",
    width: "100%",
    height: "auto",
    color: "white"
};

const actions = {
    selectedCategory,
    selectedTest
};

const mapState = state => ({
    testSubject: state.selection.selectedTest,
    selectedCollection: state.selection.selectedCategory,
    testId: state.selection.selectedTest,
    testTree: state.userTestTreeReducer.testTree,
    loading: state.async.loading
});

class TestDetailHeader extends Component {
    isTaken = testId => {
        const { selectedCollection, testTree } = this.props;
        if (testTree["testTree"]) {
            if (testTree["testTree"].hasOwnProperty(selectedCollection)) {
                let testArray = testTree["testTree"][selectedCollection];
                for (let i = 0; i < testArray.length; i++) {
                    if (testId === testArray[i]) {
                        return true;
                    }
                }
            }
            return false;
        }
    };

    render() {
        const { testId, testSubject, loading } = this.props;
        return (
            <Segment.Group>
                <Segment basic attached="top" style={{ padding: "0" }}>
                    <Image src={CardImage} fluid style={eventImageStyle} />

                    <Segment basic style={eventImageTextStyle}>
                        <Item.Group>
                            <Item>
                                <Item.Content>
                                    <Header
                                        size="huge"
                                        content={testId}
                                        style={{ color: "white" }}
                                    />
                                    <p>Category: {testSubject}</p>
                                </Item.Content>
                            </Item>
                        </Item.Group>
                    </Segment>
                </Segment>

                <Segment attached="bottom">
                    {this.isTaken(testId) ? (
                        <Button
                            color="orange"
                            loading={loading}
                            as={Link}
                            to={{ pathname: "/test" }}
                        >
                            View answers
                        </Button>
                    ) : (
                        <Button
                            color="teal"
                            loading={loading}
                            as={Link}
                            to={{ pathname: "/test" }}
                        >
                            Take This Test
                        </Button>
                    )}
                </Segment>
            </Segment.Group>
        );
    }
}

export default connect(
    mapState,
    actions
)(TestDetailHeader);
